var React = require('react');

function IconActivityIndicatorLargeTrack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4ZM0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z","fill":"black"}));
}

IconActivityIndicatorLargeTrack.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = IconActivityIndicatorLargeTrack;

IconActivityIndicatorLargeTrack.default = IconActivityIndicatorLargeTrack;
